"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _cartWatcher = _interopRequireDefault(require("./events/cart-watcher"));
var _cart = _interopRequireDefault(require("./pages/cart"));
var _pdp = _interopRequireDefault(require("./pages/pdp"));
var _utils = require("./utils/utils");
var _validate = require("./apis/bwa/validate");
var _constants = require("./constants/constants");
var _home = _interopRequireDefault(require("./pages/home"));
var _mshopEventHandler = require("./events/mshop-event-handler");
var _bwaEmptyWidget = _interopRequireDefault(require("./components/bwa-empty-widget/bwa-empty-widget"));
function main() {
  return _main.apply(this, arguments);
}
function _main() {
  _main = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var _window$bwaValidateSt;
    var storeId, treatments, page;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          storeId = window.storeId;
          _context.next = 3;
          return (0, _utils.jsLoader)("https://buywithamazon.amazon.in/utm-handler.min.js");
        case 3:
          if (window.handleUtmExperience) {
            window.handleUtmExperience();
          }
          if (window.isBwAEnabled()) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return");
        case 6:
          _context.next = 8;
          return (0, _validate.validateStore)(storeId, [_constants.EXPERIMENT_IDS.RTO_CHECKOUT, _constants.EXPERIMENT_IDS.COGNITO_LOGIN, _constants.EXPERIMENT_IDS.REVAMPED_ASP], (0, _utils.getUtmExperience)());
        case 8:
          window.bwaValidateStoreResponse = _context.sent;
          treatments = (_window$bwaValidateSt = window.bwaValidateStoreResponse) === null || _window$bwaValidateSt === void 0 ? void 0 : _window$bwaValidateSt.treatments; // Mirror the FULL treatments map (which always carries bwa-experience, resolved server-side)
          // so every current and future experiment is published on GA/Katal events with no further
          // client changes. The per-experiment setters below stay: they gate behaviour.
          (0, _utils.setEventExperiments)(treatments);
          // Checkout events come from the Shopify pixel, which has no BwA payload; it reads this to
          // stamp ecp_store_id.
          (0, _utils.setStoreId)(storeId);
          if (treatments !== null && treatments !== void 0 && treatments[_constants.EXPERIMENT_IDS.RTO_CHECKOUT]) {
            (0, _utils.setRtoTreatment)(treatments[_constants.EXPERIMENT_IDS.RTO_CHECKOUT]);
          }
          if (treatments !== null && treatments !== void 0 && treatments[_constants.EXPERIMENT_IDS.COGNITO_LOGIN]) {
            (0, _utils.setCognitoLoginTreatment)(treatments[_constants.EXPERIMENT_IDS.COGNITO_LOGIN]);
          }
          if (treatments !== null && treatments !== void 0 && treatments[_constants.EXPERIMENT_IDS.REVAMPED_ASP]) {
            (0, _utils.setRevampedAspTreatment)(treatments[_constants.EXPERIMENT_IDS.REVAMPED_ASP]);
          }
          _context.next = 17;
          return loadMerchantConfig(storeId);
        case 17:
          // Apply any per-page selector/config overrides from the matched pageRule before
          // the page flow reads selectors from bwaMerchantConfig. No-op when there is no
          // matching rule or the rule carries no overrides.
          (0, _utils.applyPageRuleOverrides)((0, _utils.matchPageRule)());
          new _bwaEmptyWidget["default"]();
          loadProductRatingsScript(window.bwaValidateStoreResponse.roaInstanceId);
          loadProductReviewsScript(window.bwaValidateStoreResponse.roaInstanceId);
          page = (0, _utils.detectPage)();
          if (page === "Home") {
            new _home["default"]();
          } else if (page === "PDP") {
            new _pdp["default"]();
          } else if (page === "Cart") {
            new _cart["default"]();
          } else {
            console.error("BwA: Unknown page detected. Path: ".concat(window.location.pathname));
          }
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _main.apply(this, arguments);
}
function loadMerchantConfig(_x) {
  return _loadMerchantConfig.apply(this, arguments);
}
function _loadMerchantConfig() {
  _loadMerchantConfig = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(storeId) {
    var version, merchantJS, merchantCSS;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          version = '@@VERSION';
          merchantJS = "".concat("https://buywithamazon.amazon.in/v2/config", "/").concat(storeId, "/").concat(_constants.MERCHANT_CONFIG_JS, "?v=").concat(version);
          _context2.next = 4;
          return (0, _utils.jsLoader)(merchantJS);
        case 4:
          merchantCSS = "".concat("https://buywithamazon.amazon.in/v2/config", "/").concat(storeId, "/").concat(_constants.MERCHANT_CONFIG_CSS, "?v=").concat(version);
          _context2.next = 7;
          return (0, _utils.cssLoader)(merchantCSS);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _loadMerchantConfig.apply(this, arguments);
}
function loadProductRatingsScript(roaInstanceId) {
  var scriptSrc = "https://cdn.elements.amazon/elements/amazon-product-rating/v1.0/web-component.js";
  (0, _utils.loadRfaScript)(scriptSrc, roaInstanceId);
}
function loadProductReviewsScript(roaInstanceId) {
  var scriptSrc = "https://cdn.elements.amazon/elements/amazon-product-reviews/v1.0/web-component.js";
  (0, _utils.loadRfaScript)(scriptSrc, roaInstanceId);
}
window.addEventListener("DOMContentLoaded", function () {
  _cartWatcher["default"].init();
  (0, _utils.cssLoader)("https://buywithamazon.amazon.in/v2/assets/global.min.css");
  (0, _mshopEventHandler.setupMShopEventHandlers)();
});
main();
//# sourceMappingURL=app.js.map
